import {
  createBaseThemeOptions,
  createUnifiedTheme,
  palettes,
} from '@backstage/theme';
import { fonts } from './fonts';
import headerImage from '../assets/images/Tensure_PatternBackgrounds_Pink_Yellow.png';
import { black, cream, white, yellow, purple, green, red, blue, adjustColor } from './colors';

const overrideTextColor = black;
export const tensureDarkTheme = createUnifiedTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@font-face': fonts,
        '@global': {
          body: {
            fontWeight: 350,
          },
        },
      },
    },
    BackstageHeaderLabel: {
      styleOverrides: {
        label: {
          color: overrideTextColor,
        },
        value: {
          color: overrideTextColor,
        },
      },
    },
    PluginCatalogEntityContextMenu: {
      styleOverrides: {
        button: {
          color: overrideTextColor,
        },
      },
    },
    CatalogReactEntityDisplayName: {
      styleOverrides: {
        icon: {
          color: overrideTextColor,
        },
      },
    },

    BackstageHeader: {
      styleOverrides: {
        header: ({ theme }) => ({
          width: 'auto',
          margin: '0px',
          boxShadow: 'none',
          borderBottom: `2px solid ${theme.palette.secondary.main}`,
          backgroundImage: `url(${headerImage})`, // Set the background image
          backgroundSize: 'cover', // Cover the entire header    
          backdropFilter: 'blur(50px)',      
          color: overrideTextColor,
        }),
        title: {
          color: overrideTextColor,
          lineHeight: '1.5',

        },
        subtitle: {
          color: overrideTextColor,
        },
        type: {
          color: overrideTextColor,
        },
      },
    },
  },
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: {
        main: cream,
      },
      secondary: {
        main: black,
      },
      error: {
        main: red,
      },
      warning: {
        main: yellow,
      },
      info: {
        main: blue,
      },
      success: {
        main: green,
      },
      background: {
        default: adjustColor(black, 30),
        paper: adjustColor(black, 35),
      },
      banner: {
        info: blue,
        error: red,
        text: cream,
        link: blue,
      },
      header: {
        text: white,
      },
      errorBackground: red,
      warningBackground: yellow,
      infoBackground: blue,
      navigation: {
        background: adjustColor(black, 20),
        indicator: green,
        color: white,
        selectedColor: purple,
      },
    },
    typography: {
      fontFamily: 'ABC Oracle',
      htmlFontSize: 16,
      h1: {
        fontSize: 54,
        fontWeight: 700,
        marginBottom: 10,
        fontFamily: 'Gooper',
      },
      h2: {
        fontSize: 40,
        fontWeight: 700,
        marginBottom: 8,
        fontFamily: 'Gooper',
      },
      h3: {
        fontSize: 32,
        fontWeight: 700,
        marginBottom: 6,
        fontFamily: 'Gooper',
      },
      h4: {
        fontWeight: 300,
        fontSize: 28,
        marginBottom: 6,
        fontFamily: 'Gooper',
      },
      h5: {
        fontWeight: 700,
        fontSize: 24,
        marginBottom: 4,
        fontFamily: 'Gooper',
      },
      h6: {
        fontWeight: 700,
        fontSize: 20,
        marginBottom: 2,
        fontFamily: 'Gooper',
      },

    }
  }),
  defaultPageTheme: 'home',
});